import { db } from "../firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import paymentService from "./paymentService";

const getAllUsers = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));
    const users = [];
    querySnapshot.forEach((doc) => {
        users.push({ _id: doc.id, ...doc.data() });
    });
    return users;
};

const updateUserProfile = async (userId, profileData) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, profileData);
    return { message: "Profile updated successfully" };
};

const updateUserPayment = async (userId, payment) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, { currentPayment: payment });
    return { message: "Payment updated successfully" };
};

const updateUserStats = async (userId, totalProjects, activeProjects, completedProjects, totalEarnings) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
        totalProjects,
        activeProjects,
        completedProjects,
        totalEarnings
    });
    return { message: "Stats updated successfully" };
};

const updateUserLicense = async (userId, licenseKey, licenseExpiry) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
        licenseKey,
        licenseExpiry
    });
    return { message: "License updated successfully" };
};

const clearUserData = async (userId) => {
    const userRef = doc(db, "users", userId);

    // 1. Delete all payment history
    await paymentService.deleteUserPayments(userId);

    // 2. Reset user stats and current payment
    await updateDoc(userRef, {
        currentPayment: 0,
        totalProjects: 0,
        activeProjects: 0,
        completedProjects: 0,
        totalEarnings: 0
    });

    return { message: "User data cleared successfully" };
};

const userService = {
    getAllUsers,
    updateUserProfile,
    updateUserPayment,
    updateUserStats,
    updateUserLicense,
    clearUserData,
};

export default userService;
